// CommandCenterLayout.tsx - New layout with CommandHub + Dashboard
import React from 'react';
import CommandHub from './CommandHub';
import AgentDashboardPanel from '../widgets/AgentDashboardPanel';
import { AgentProfile, TestResult } from '../../types';

interface CommandCenterLayoutProps {
  // Agent related
  agents: AgentProfile[];
  selectedAgent: string;
  onSelectAgent: (name: string) => void;

  apis: any[];
  applications: any[];

  currentScope?: 'agent' | 'api' | 'application';
  onScopeChange?: (scope: 'agent' | 'api' | 'application') => void;
  selectedAPI?: string;
  onSelectAPI?: (api: string) => void;
  selectedApplication?: string;
  onSelectApplication?: (app: string) => void;

  // Actions
  onActionClick: (action: string) => void;

  // Status
  isGeneratingTests: boolean;
  isTestRunning: boolean;

  // Dashboard data
  currentAgent?: AgentProfile;
  results: Map<string, TestResult>;
  defects: any[];
  aiConfig?: any;
  lastDataRefresh: number;
}

const CommandCenterLayout: React.FC<CommandCenterLayoutProps> = ({
  agents,
  selectedAgent,
  onSelectAgent,
  apis,
  applications,
  onActionClick,
  isGeneratingTests,
  isTestRunning,
  currentAgent,
  results,
  defects,
  aiConfig,
  lastDataRefresh,
  currentScope,
  onScopeChange,
  selectedAPI,
  onSelectAPI,
  selectedApplication,
  onSelectApplication
}) => {
  const [isDashboardCollapsed, setIsDashboardCollapsed] = React.useState(false);

  return (
    <div className="command-center-layout">
      {/* Column 1: Command Hub */}
      <CommandHub
        agents={agents}
        selectedAgent={selectedAgent}
        onSelectAgent={onSelectAgent}
        apis={apis}
        applications={applications}
        onActionClick={onActionClick}
        isGeneratingTests={isGeneratingTests}
        isTestRunning={isTestRunning}
        currentScope={currentScope}
        onScopeChange={onScopeChange}
        selectedAPI={selectedAPI}
        onSelectAPI={onSelectAPI}
        selectedApplication={selectedApplication}
        onSelectApplication={onSelectApplication}
      />

      {/* Column 2 & 3: Dashboard Columns */}
      <AgentDashboardPanel
        selectedAgent={selectedAgent}
        currentAgent={currentAgent}
        results={results}
        defects={defects}
        isCollapsed={isDashboardCollapsed}
        onToggleCollapse={() => setIsDashboardCollapsed(!isDashboardCollapsed)}
        aiConfig={aiConfig}
        lastDataRefresh={lastDataRefresh}
        currentScope={currentScope}
        selectedAPI={selectedAPI}
        selectedApplication={selectedApplication}
        apis={apis}
        applications={applications}
      />
    </div>
  );
};

export default CommandCenterLayout;
